export default "__VITE_ASSET__BUds3jib__"